export default {
  fr: {
    package: 'boîte',
    packages: 'boîtes',
    packageOf: 'boîte de',
    packagesOf: 'boîtes de',
    during: 'pendant',
    take_s_: 'prise(s)',
    weekly: '/semaine',
    monthly: '/mois',
    daily: '/jour',
    the: 'le',
    onDay: 'le jour',
    on: 'le',
    afterwakingup: 'Au lever',
    afterbreakfast: 'Après ptit déj.',
    afterdinner: 'Après rep. soir',
    afterlunch: 'Après rep. midi',
    afternoon: 'Après-midi',
    beforebreakfast: 'Avant ptit déj.',
    beforedinner: 'Avant rep. soir',
    beforelunch: 'Avant rep. midi',
    duringbreakfast: 'Pdt ptit déj.',
    duringdinner: 'Pdt rep. soir',
    duringlunch: 'Pdt rep. midi',
    betweenbreakfastandlunch: 'Entre ptit déj et rep. midi',
    betweenlunchanddinner: 'Entre rep. midi et rep. soir',
    betweendinnerandsleep: 'Entre rep. soir et couch.',
    evening: 'Soir',
    knownuse: 'Usage connu',
    morning: 'Matin',
    night: 'Avt couch.',
    midday: 'Midi',
    noon: 'Midi',
    at: 'à',
    thehourofsleep: 'Au coucher',
  },
  en: {
    package: 'package',
    packages: 'packages',
    packageOf: 'package of',
    packagesOf: 'packages of',
    during: 'during',
    take_s_: 'take(s)',
    weekly: 'weekly',
    monthly: 'monthly',
    daily: 'daily',
    the: 'the',
    onDay: 'on day',
    on: 'on',
    afterwakingup: 'After Waking Up',
    afterbreakfast: 'After Breakfast',
    afterdinner: 'After Dinner',
    afterlunch: 'After Lunch',
    afternoon: 'Afternoon',
    beforebreakfast: 'Before Breakfast',
    beforedinner: 'Before Dinner',
    beforelunch: 'Before Lunch',
    duringbreakfast: 'During Breakfast',
    duringdinner: 'During Dinner',
    duringlunch: 'During Lunch',
    betweenbreakfastandlunch: 'Between Breakfast and Lunch',
    betweenlunchanddinner: 'Between Lunch and Dinner',
    betweendinnerandsleep: 'Between Dinner and Sleep',
    evening: 'Evening',
    knownuse: 'Known Usage',
    morning: 'Morning',
    night: 'Night',
    midday: 'Midday',
    noon: 'Noon',
    at: 'at',
    thehourofsleep: 'At Bedtime',
  },
  nl: {
    package: 'verpakking',
    packages: 'verpakkingen',
    packageOf: 'verpakking van',
    packagesOf: 'verpakkingen van',
    during: 'gedurende',
    take_s_: 'inname(s)',
    weekly: 'wekelijks',
    monthly: 'maandelijks',
    daily: 'dagelijks',
    the: 'de',
    onDay: 'op dag',
    on: 'op',
    afterwakingup: 'Bij het opstaan',
    afterbreakfast: 'Na ontbijt',
    afterdinner: 'Na avondeten',
    afterlunch: 'Na middageten',
    afternoon: 'Namiddag',
    beforebreakfast: 'Voor ontbijt',
    beforedinner: 'Voor avondeten',
    beforelunch: 'Voor middageten',
    duringbreakfast: 'Tijdens ontbijt',
    duringdinner: 'Tijdens avondeten',
    duringlunch: 'Tijdens middageten',
    betweenbreakfastandlunch: 'Tussen ontbijt en middageten',
    betweenlunchanddinner: 'Tussen middag- en avondeten',
    betweendinnerandsleep: 'Tussen avondmaal en slapeneten',
    evening: 'Avond',
    knownuse: 'Gekend gebruik',
    morning: "'s Morgens",
    night: 'Vóór slapengaan',
    midday: 'Middag',
    noon: 'Middag',
    at: 'om',
    thehourofsleep: 'Voor het slapen',
  },
}
